export class Card {
  private cardNumber: string;
  private isBlocked: boolean;
  private isCancelled: boolean;

  constructor(cardNumber: string = "") {
    this.cardNumber = cardNumber;
  }

  setCardNumber(value: string): void {
    this.cardNumber = value;
  }

  getCardNumber(): string {
    return this.cardNumber;
  }

  setIsBlocked(value: boolean): void {
    this.isBlocked = value;
  }

  getIsBlocked(): boolean {
    return this.isBlocked;
  }

  setIsCancelled(value: boolean): void {
    this.isCancelled = value;
  }

  getIsCancelled(): boolean {
    return this.isCancelled;
  }
}
